export enum OfferType {
  EXCHANGE = "exchange",
  REFILL = "refill",
}

export interface IOfferTab {
  suburb: string;
  postcode: string;
  tab: OfferType;
}

export interface IOfferTabAnalytics extends IOfferTab {
  sentExchange: boolean;
  sentRefill: boolean;
}

export function OfferTab(
  tab: OfferType,
  suburb?: string,
  postcode?: string
): IOfferTab {
  return {
    suburb: suburb?.toUpperCase() || "", // for presentation AND key,
    postcode: postcode || "",
    tab,
  };
}

function hasNeverBeenSent(sent?: IOfferTabAnalytics): boolean {
  return !sent;
}

function hasLocationChanged(
  test: IOfferTab,
  sent: IOfferTabAnalytics
): boolean {
  return sent.suburb !== test.suburb || sent.postcode !== test.postcode;
}

function hasTabNotBeenSent(test: IOfferTab, sent: IOfferTabAnalytics): boolean {
  switch (test.tab) {
    case OfferType.EXCHANGE:
      return !sent.sentExchange;
    case OfferType.REFILL:
      return !sent.sentRefill;
    default:
      return false;
  }
}

export function OfferTabAnalytics(
  offerTab: IOfferTab,
  sent?: IOfferTabAnalytics
): IOfferTabAnalytics {
  if (hasNeverBeenSent(sent) || hasLocationChanged(offerTab, sent!)) {
    return {
      ...offerTab,
      sentExchange: offerTab.tab === OfferType.EXCHANGE,
      sentRefill: offerTab.tab === OfferType.REFILL,
    };
  }

  return {
    ...offerTab,
    sentExchange: sent!.sentExchange || offerTab.tab === OfferType.EXCHANGE,
    sentRefill: sent!.sentRefill || offerTab.tab === OfferType.REFILL,
  };
}

export function shouldSendOfferTabAnalytics(
  test: IOfferTab,
  sent?: IOfferTabAnalytics
): boolean {
  if (hasNeverBeenSent(sent)) {
    return true;
  }

  if (hasLocationChanged(test, sent!)) {
    return true;
  }

  return hasTabNotBeenSent(test, sent!);
}

export function formatOfferTabForAnalytics(offerTab: IOfferTab): string {
  return [offerTab.suburb, offerTab.postcode, offerTab.tab].join("|");
}
